import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

const GridTitle = ({ children, className, ...props }) => (
  <h2 {...props} className={classnames('grid__title', className)}>
    {children}
  </h2>
);

GridTitle.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default React.memo(GridTitle);
